/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalysisHistory
 */
export interface AnalysisHistory {
    /**
     * Analyse-Datum
     * @type {Date}
     * @memberof AnalysisHistory
     */
    date: Date;
    /**
     * Anzahl analysierter Steine
     * @type {number}
     * @memberof AnalysisHistory
     */
    bricksAnalyzed: number;
    /**
     * Set-ID
     * @type {string}
     * @memberof AnalysisHistory
     */
    setId: string;
    /**
     * Art der Analyse (SIMPLE = nur Stückliste, PROTECTED = nur geschützte Steine, ALL = vollständige Analyse)
     * @type {string}
     * @memberof AnalysisHistory
     */
    analyzeType: AnalysisHistoryAnalyzeTypeEnum;
}


/**
 * @export
 */
export const AnalysisHistoryAnalyzeTypeEnum = {
    Simple: 'SIMPLE',
    Protected: 'PROTECTED',
    All: 'ALL',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type AnalysisHistoryAnalyzeTypeEnum = typeof AnalysisHistoryAnalyzeTypeEnum[keyof typeof AnalysisHistoryAnalyzeTypeEnum];


/**
 * Check if a given object implements the AnalysisHistory interface.
 */
export function instanceOfAnalysisHistory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "bricksAnalyzed" in value;
    isInstance = isInstance && "setId" in value;
    isInstance = isInstance && "analyzeType" in value;

    return isInstance;
}

export function AnalysisHistoryFromJSON(json: any): AnalysisHistory {
    return AnalysisHistoryFromJSONTyped(json, false);
}

export function AnalysisHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'bricksAnalyzed': json['bricksAnalyzed'],
        'setId': json['setId'],
        'analyzeType': json['analyzeType'],
    };
}

export function AnalysisHistoryToJSON(value?: AnalysisHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': (value.date.toISOString()),
        'bricksAnalyzed': value.bricksAnalyzed,
        'setId': value.setId,
        'analyzeType': value.analyzeType,
    };
}

